import { BaseModel } from "sjs-base-model";
import InfoDocumentsModel from "./InfoDocumentsModel";
export default class DocumentsInfoModel extends BaseModel {
    public readonly idEstimateRequest: number = 0;
    public readonly idRequestType: number = 0;
    public readonly idMacroProduct: number = 0;
    public readonly idAdministrativeCategory: number = 0;
    public readonly infoDocumentsToBeSigned: InfoDocumentsModel[] = [];
    public readonly infoDocumentsToBeUploaded: InfoDocumentsModel[] = [];
    public readonly idEstimate: number = 0;

    constructor(data: Partial<DocumentsInfoModel>) {
        super();

        this.update(data);
    }
}
